import React, { useState, useEffect } from "react";
import { Button, Tooltip } from "antd";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";

import ThemeStore from "../stores/ThemeStore";

interface ThemeToggleProps {
  className?: string;
  size?: "small" | "middle" | "large";
  style?: React.CSSProperties;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className, size = "middle", style }) => {
  const [isDarkMode, setIsDarkMode] = useState(ThemeStore.getIsDarkMode());

  useEffect(() => {
    const handleThemeChange = () => {
      setIsDarkMode(ThemeStore.getIsDarkMode());
    };

    ThemeStore.on("change", handleThemeChange);

    return () => {
      ThemeStore.removeListener("change", handleThemeChange);
    };
  }, []);

  const handleToggle = () => {
    ThemeStore.toggleTheme();
  };

  return (
    <Tooltip title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}>
      <Button
        type="text"
        icon={isDarkMode ? <SunOutlined /> : <MoonOutlined />}
        onClick={handleToggle}
        className={className}
        size={size}
        style={{
          color: isDarkMode ? "#faad14" : "#1890ff",
          ...style,
        }}
      />
    </Tooltip>
  );
};

export default ThemeToggle;